module.exports = __webpack_public_path__ + "img/cdm-head.a8ec2475.svg";